export default __webpack_public_path__ + "static/media/tour1.9a292e6c.png";